"use client";

/**
 * We re-export in order to prevent having to install react-intl in consuming
 * repositories. react-intl works using the context api, therefore having
 * multiple copies of it at once is problematic.
 */
import { observer } from "mobx-react";
import React from "react";

import {
  UnobservedIntlProvider,
  BothOrNeither,
} from "../../common/localization/IntlProviderBase";

export const IntlProviderBase: React.FC<
  React.PropsWithChildren<BothOrNeither>
> = ({ children, ...args }) => (
  <UnobservedIntlProvider {...args}>{children}</UnobservedIntlProvider>
);

export const IntlProvider = observer(IntlProviderBase);
